import * as MD from '@material-ui/core';
//import   MuiTextField from '@material-ui/core/TextField';
import { TextField } from '@material-ui/core';
import MuiButton from '@material-ui/core/Button';
import MuiCheckbox from '@material-ui/core/Checkbox';
import { grey } from '@material-ui/core/colors';
import MuiFormControlLabel from '@material-ui/core/FormControlLabel';
import MuiRadio from '@material-ui/core/Radio';
import { withStyles } from '@material-ui/core/styles';
import MuiTableCell from '@material-ui/core/TableCell';
//Router
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const ButtonDensed = MD.withStyles({
	root: {
		padding: '1px 8px',
		fontSize: '12px',
		color: '#fff',
		textTransform: 'none',
	},
})(MuiButton);

export const ButtonDensedNoColor = MD.withStyles({
	root: {
		padding: '1px 8px',
		fontSize: '12px',
	},
})(MuiButton);

export const DensedTextField = styled(TextField)`
	.MuiInputBase-input {
		padding: 4px;
		font-size: 13px;
	}
	.MuiInputLabel-formControl {
		top: -7px;
		font-size: 13px;
		font-weight: 300;
	}
	.MuiFormLabel-root.Mui-focused {
		top: 0;
	}
	.MuiInputLabel-shrink {
		top: 0 !important;
	}
`;

export const DensedTextFieldDark = styled(TextField)`
	.MuiInputBase-input {
		padding: 4px;
		font-size: 13px;
	}
	.MuiInputLabel-formControl {
		top: -7px;
		font-size: 13px;
		font-weight: 100;
	}
	.MuiFormLabel-root.Mui-focused {
		top: 0;
	}
	.MuiInputLabel-shrink {
		top: 0 !important;
	}
	input {
		color: #000;
	}
`;

export const DarkRadio = withStyles({
	root: {
		color: grey[400],
		'&$checked': {
			color: grey[600],
		},
	},

	checked: {},
})(MuiRadio);

export const DarkCheckbox = withStyles({
	root: {
		color: grey[300],
	},

	checked: {},
})(MuiCheckbox);

export const FormControlLabelMedium = withStyles({
	label: {
		fontSize: '14px',
	},
})(MuiFormControlLabel);

export const FormControlLabelSmall = withStyles({
	label: {
		fontSize: '13px',
	},
})(MuiFormControlLabel);

export const FormControlLabelTopLeftPlacement = withStyles({
	label: {
		fontSize: '14px',
		display: 'flex',
		alignSelf: 'flex-start',
	},
})(MuiFormControlLabel);

export const StyledLink = styled(Link)`
	text-decoration: none;
	color: #fff;

	&:focus,
	&:hover,
	&:visited,
	&:link,
	&:active {
		text-decoration: none;
	}
`;

export const TableHeaderCell = withStyles((theme) => ({
	root: {
		padding: '0px 5px',
		fontSize: '12px',
		textTransform: 'uppercase',
		fontWeight: 500,
		backgroundColor: theme.palette.background.paper,
		color: theme.palette.text.primary,
	},
}))(MuiTableCell);

export const TableCell = withStyles((theme) => ({
	root: {
		padding: '2px',
		fontSize: '11px',
		fontWeight: 500,
		color: theme.palette.text.primary,
		// borderBottom: '1px solid #EEEEEE'
	},
}))(MuiTableCell);
